export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if (('' + time).length === 10) time = parseInt(time) * 1000
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}


export function getPrototype(value, diffType = '') {


    const prototypeArray = {
        "[object Array]": 'array'
        , "[object Number]": 'number'
        , "[object String]": 'string'
        , "[object Function]": 'function'
    };

    const prototypeText = Object.prototype.toString.call(value);
    const result = prototypeArray[prototypeText];

    if (diffType) {

        if (diffType === result) {
            return true;
        } else {
            return false;
        }
    }

    return result ? result : prototypeText;


}

export function releaseObjectLink(v) {


    return JSON.parse(JSON.stringify(v));

}

export function formatNum(f, digit = 2, toNumber = false) {
    var m = Math.pow(10, digit);
    let num = parseInt(f * m, 10) / m;

    if (toNumber) {
        return num;
    }

    let tempNumArr = num.toString().split('.');

    let _digitLength = 0;

    if (tempNumArr.length > 1) {
        _digitLength = tempNumArr[1].length;
    }

    if (_digitLength === 0 && _digitLength !== digit) {
        num = num + '.';
    }

    if (_digitLength !== digit) {
        for (let i = 1; i <= digit - _digitLength; i++) {
            num = num + '0';
        }
    }

    return num;

}


/* 获取时间段内属于星期一(*)的日期们
 * begin: 开始时间
 * end：结束时间
 * weekNum：星期几 {number}
 */
export function getWeekDate(begin, end, weekNum) {
    var dateArr = new Array();
    var stimeArr = begin.split("-");//=>["2018", "01", "01"]
    var etimeArr = end.split("-");//=>["2018", "01", "30"]

    var stoday = new Date();
    stoday.setUTCFullYear(stimeArr[0], stimeArr[1] - 1, stimeArr[2]);
    var etoday = new Date();
    etoday.setUTCFullYear(etimeArr[0], etimeArr[1] - 1, etimeArr[2]);

    var unixDb = stoday.getTime();//开始时间的毫秒数
    var unixDe = etoday.getTime();//结束时间的毫秒数

    for (var k = unixDb; k <= unixDe;) {
        let needJudgeDate = msToDate(parseInt(k)).withoutTime;
        //不加这个if判断直接push的话就是已知时间段内的所有日期

        if (weekNum instanceof Array) {


            let weekIndex = weekNum.findIndex(weekItem => weekItem === new Date(needJudgeDate).getDay());
            if (weekIndex !== -1) {
                dateArr.push(needJudgeDate);
            }


        } else {

            if (new Date(needJudgeDate).getDay() === weekNum) {
                dateArr.push(needJudgeDate);
            }

        }


        k = k + 24 * 60 * 60 * 1000;
    }
    return dateArr;
}


function msToDate(msec) {
    let datetime = new Date(msec);
    let year = datetime.getFullYear();
    let month = datetime.getMonth();
    let date = datetime.getDate();
    let hour = datetime.getHours();
    let minute = datetime.getMinutes();
    let second = datetime.getSeconds();

    let result1 = year +
        '-' +
        ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
        '-' +
        ((date + 1) < 10 ? '0' + date : date) +
        ' ' +
        ((hour + 1) < 10 ? '0' + hour : hour) +
        ':' +
        ((minute + 1) < 10 ? '0' + minute : minute) +
        ':' +
        ((second + 1) < 10 ? '0' + second : second);

    let result2 = year +
        '-' +
        ((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
        '-' +
        ((date + 1) < 11 ? '0' + date : date);

    let result = {
        hasTime: result1,
        withoutTime: result2
    };

    return result;
}
